import {onDownload} from "@/libs/helper";
import {useState} from "react";
import {FiFileText, FiUploadCloud} from "react-icons/fi";
import {IoCloseCircleOutline} from "react-icons/io5";
interface FileUploadProps {
  label: string;
  onChange: (file: File | null) => void; // add this
  error?: string; // add this
  userVehicleFileUrl?: string;
}
export default function FileUpload({
  label,
  onChange,
  error,
  userVehicleFileUrl
}: FileUploadProps) {
  const [file, setFile] = useState<File | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] ?? null;
    setFile(file);
    onChange(file);
  };

  const handleRemove = () => {
    setFile(null);
    onChange(null);
  };

  const formatFileSize = (size: number) => {
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
    return `${(size / (1024 * 1024)).toFixed(1)} MB`;
  };

  return (
    <div className="">
      <p className="mb-1 text-sm font-medium">{label}</p>

      {!file ? (
        // Upload box
        <label
          htmlFor={label}
          className="flex cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 p-4 hover:bg-gray-100"
        >
          <FiUploadCloud className="mb-1 text-3xl text-neo-green" />
          <span className="text-sm font-medium text-neo-green">
            Click to Upload
          </span>
          <span className="text-xs text-gray-500">or drag and drop</span>

          <input
            id={label}
            type="file"
            className="hidden"
            onChange={handleFileChange}
          />
        </label>
      ) : (
        // Uploaded file row
        <div className="flex items-center justify-between rounded-lg border border-gray-200 bg-white px-4 py-2 shadow-sm">
          <div className="flex items-center gap-2">
            <FiFileText className="text-lg text-yellow-500" />
            <div>
              <p className="text-sm font-medium text-gray-800">{file.name}</p>
              <p className="text-xs text-gray-500">
                {formatFileSize(file.size)}
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={handleRemove}
            className="text-red-500 hover:text-red-600"
          >
            <IoCloseCircleOutline className="text-xl" />
          </button>
        </div>
      )}

      <a
        href="#"
        onClick={e => {
          e.preventDefault();
          onDownload(
            userVehicleFileUrl,
            label === "Upload Student Data" ? "userData.csv" : "vehicleData.csv"
          );
        }}
        className="float-end text-xs text-blue-600 underline hover:text-blue-800"
      >
        Download CSV file
      </a>
    </div>
  );
}
